var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6457 1.93689L15.4123 10.5728C14.2675 11.7581 13.4309 12 11.978 12C10.569 12 9.73249 11.7581 8.58773 10.5728L0.354277 1.96108C-0.39422 1.16281 0.0900993 0.485481 1.36695 0.171009C2.59976 -0.119273 4.0087 -0.0950824 4.71317 0.679003L11.934 8.46824L12.1981 8.46824L19.3309 0.679004C20.0353 -0.0950817 21.4443 -0.119272 22.6331 0.17101C23.9099 0.485483 24.3942 1.13862 23.6457 1.93689Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.d12749008700842dc5c0cf9548c31060.svg";
export { ForwardRef as ReactComponent };